declare namespace $ {

	type $shm_hitalama_map_widget_float_notebook2_adds_line__Map_page_shm_hitalama_map_widget_float_notebook2_adds_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['Map_page'] >
	>
	type $shm_hitalama_map_widget_float_notebook2_adds_line__add_types_shm_hitalama_map_widget_float_notebook2_adds_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds['add_types'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['add_types'] >
	>
	type $shm_hitalama_map_widget_float_notebook2_adds_line__showed_shm_hitalama_map_widget_float_notebook2_adds_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds['add_line_showed'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['showed'] >
	>
	type $shm_hitalama_map_widget_float_notebook2_adds_line__left_px_shm_hitalama_map_widget_float_notebook2_adds_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds['add_line_left_px'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['left_px'] >
	>
	type $shm_hitalama_map_widget_float_notebook2_adds_line__top_px_shm_hitalama_map_widget_float_notebook2_adds_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds['add_line_top_px'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['top_px'] >
	>
	type $shm_hitalama_map_widget_float_notebook2_adds_line__real_pos_shm_hitalama_map_widget_float_notebook2_adds_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds['add_line_real_pos'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['real_pos'] >
	>
	export class $shm_hitalama_map_widget_float_notebook2_adds extends $mol_view {
		add_lines( ): readonly(any)[]
		add_types( ): readonly(any)[]
		add_line_showed( id: any): boolean
		add_line_left_px( id: any): string
		add_line_top_px( id: any): string
		add_line_real_pos( id: any): readonly(any)[]
		Map_page( ): $shm_hitalama_map_page
		Notebook( ): $shm_hitalama_map_widget_float_notebook2
		sub( ): ReturnType< $shm_hitalama_map_widget_float_notebook2_adds['add_lines'] >
		Add_line( id: any): $shm_hitalama_map_widget_float_notebook2_adds_line
	}
	
}

//# sourceMappingURL=adds.view.tree.d.ts.map